function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M327.4,15.2C317.6,5.4,304.6,0,290.8,0S264,5.4,254.2,15.2L180,89.4c-27.4,9.5-111.2,40.5-145,74.3 c-20.8,20.8-33.1,47.7-34.8,75.7c-1.7,29,8.1,55.8,27.7,75.3c18,18,42.5,27.9,69,27.9h0c29.9,0,59.8-12.7,82-35 c33.8-33.8,64.8-117.6,74.3-145l74.2-74.2c9.8-9.8,15.2-22.8,15.2-36.6C342.6,38,337.2,25,327.4,15.2z M228.5,114.3 c0,0-5.9-5.9-5.9-5.9L285,46c1.5-1.5,3.6-2.4,5.8-2.4s4.2,0.9,5.8,2.4c1.5,1.5,2.4,3.6,2.4,5.8c0,2.2-0.9,4.2-2.4,5.8L234.2,120 L228.5,114.3z M204.6,168.9c-15.7,41.4-37.9,89.4-56.5,107.9C134,290.9,115.4,299,96.9,299c-6.7,0-13.2-1.1-19.2-3.3L204.6,168.9z  M43.7,241.9c1-17.4,8.9-34.2,22.1-47.4c18.5-18.5,66.6-40.7,107.9-56.5L46.8,264.9C44.3,257.8,43.2,250,43.7,241.9z"
});

var SvgBakingIcon = function SvgBakingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342.6 342.6",
    width: "34px",
    height: "100%",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBakingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baking-icon.226a7d15.svg";
export { ForwardRef as ReactComponent };